import http from '@axios'
import paramsConverter from './utils/paramsConverter'

const resource = '/api/v1/rapor'

export default {
  list(params = {}) {
    const paramsString = paramsConverter(params)

    return http.get(`${resource}${paramsString}`)
  },
  add(raport) {
    return http.post(`${resource}`, raport, { headers: { 'Content-Type': 'multipart/form-data' } })
  },
  get(uuid) {
    return http.get(`${resource}/${uuid}`)
  },
  update(raport, uuid) {
    return http.post(`${resource}/${uuid}?_method=PATCH`, raport, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
  },
  destroy(uuid) {
    return http.delete(`${resource}/${uuid}`)
  },

}
